import { Form, Input, Modal } from '@maxtropy/components';
import { useEffect } from 'react';

interface AddClassificationModalProps {
  open: boolean;
  title?: string;
  initialName?: string;
  names: string[];
  onCancel: () => void;
  onOk: (name: string) => void;
}

const AddClassificationModal: React.FC<AddClassificationModalProps> = ({
  open,
  title = '新增分类',
  initialName,
  names,
  onCancel,
  onOk,
}) => {
  const [form] = Form.useForm<{ name: string }>();

  useEffect(() => {
    if (open) {
      form.setFieldsValue({ name: initialName });
    }
  }, [form, initialName, open]);

  return (
    <Modal
      title={title}
      open={open}
      onCancel={onCancel}
      contentClassName="modal-form-content"
      onOk={() => {
        form.validateFields().then(values => onOk(values.name.trim()));
      }}
      afterClose={() => form.resetFields()}
    >
      <Form form={form}>
        <Form.Item
          label="分类名称"
          name="name"
          rules={[
            { required: true, whitespace: true, message: '请输入分类名称' },
            { min: 1, max: 10, message: '分类名称需为1~10字符' },
            {
              validator: (_, value?: string) => {
                const nextValue = value?.trim();
                if (!nextValue) return Promise.resolve();
                if (names.includes(nextValue)) return Promise.reject(new Error('分类名称已存在，请勿重复输入'));
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input placeholder="请输入分类名称" maxLength={10} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default AddClassificationModal;
